
import extend from '@/utils/vuex-extend';
import { dialog } from '@/vuex-extend';
import { getOrderDetail } from '@/api/pcm/order';
import { wait } from '@/utils/wait';

export default extend(dialog, {
    namespaced: true,
    state: {
		id: 0,
		detail: {},
		list: []
    },
    actions: {
        async afterOpenDialog({ dispatch, commit, state }, payload) {
            const { id } = state;
            await wait(dispatch, 'pcm.order.detail', async function() {
				const response = await getOrderDetail(id);
				if (response.data) {
					commit('save', {
						detail: response.data.purOrderDetailInfo,
						list: response.data.goodsList
					})
				}
            })
        }
    }
})



// WEBPACK FOOTER //
// ./src/store/modules/pcm/order/detail.js